import { Component } from "@angular/core";

@Component({
  selector: "homesignin",
  templateUrl: "./homesignin.html"
})
export class HomesigninComponent {}
